import React from "react";
import { Line } from "react-chartjs-2";

const GuestCountsByTimeReport = ({
  chartData,
  chartOptions,
  storess,
  selectedDate,
  chartRef,
  containerId,
}) => (
  <div ref={chartRef} id={containerId}>
    <div className="card">
      <Line data={chartData} options={chartOptions} />
    </div>

    <div className="print-only-content">
      <h2>Report Details</h2>
      <div className="print-only-content">
        <div>
          <h3>Brand: Angels Pizza</h3>
          <h3>Store: {storess}</h3>
          <h3>Date: {selectedDate}</h3>
        </div>
      </div>

      <div style={{ fontSize: "20px" }}>
        <table className="table text-center">
          <thead>
            <tr className="d-flex">
              <th>Time</th>
              <th className="ms-5">Guest Count Solo</th>
              <th className="ms-5">Guest Count Couple</th>
              <th className="ms-5">Guest Count Small Group</th>
              <th className="ms-5">Guest Count Medium Group</th>
              <th className="ms-5">Guest Count Large Group</th>
            </tr>
          </thead>
          <tbody>
            {chartData.labels.map((label, index) => (
              <tr className="d-flex" key={`${containerId}-${index}`}>
                <td>{label}</td>
                <td>{chartData.datasets[0].data[index]}</td>
                <td>{chartData.datasets[1].data[index]}</td>
                <td>{chartData.datasets[2].data[index]}</td>
                <td>{chartData.datasets[3].data[index]}</td>
                <td>{chartData.datasets[4].data[index]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default GuestCountsByTimeReport;
